module.exports = __webpack_public_path__ + "static/media/zoom-out.0b6311d6.svg";